function Accordions() {
	this.init();
}

Accordions.prototype.init = function () {
	var self = this;
	$('.accordion li .accordion-content').each(function() {
		$(this).accordion($(this).parent());
	});
	$('.filter-category__dropdown').each(function() {
		if ($(this).closest('.dropdown-content').siblings('.dropdown-top-bar').find('.filter-category__header-link').attr('href') == "#")
			$(this).accordion($(this).closest('.dropdown-content').siblings('.dropdown-top-bar').find('.filter-category__header'));
	});
	$('.filter-tags__dropdown').accordion('.filter-tags__header');
};

$.fn.accordion = function(parent) {
	var self = $(this);
	if (!self.hasClass('-active')) {
		self.attr('inert', true);
	}
	self.parent = $(parent);
	self.data('accordion', self);
	self.parent.find('> a:not(.submenu-link), > .accordion-trigger, > .accordion-navigation-header > a[role="tab"]').attr('aria-keyshortcuts', 'ArrowDown ArrowUp').attr('title', 'Strzałka w dół: rozwiń, strzałka w górę: zwiń').click(function(e) {
		e.preventDefault();
		self.toggle();
	}).keydown(function(e) {
		if (e.key === 'ArrowDown' && !self.hasClass('-active')) {
			e.preventDefault();
			self.open();
		} else if (e.key === 'ArrowUp' && self.hasClass('-active')) {
			e.preventDefault();
			self.collapse();
		}
	});
	self.parent.find('> .submenu-link').attr('aria-keyshortcuts', 'ArrowDown ArrowUp').attr('title', 'Strzałka w dół: rozwiń, strzałka w górę: zwiń').keydown(function(e) {
		if (e.key === 'ArrowDown' && !self.hasClass('-active')) {
			e.preventDefault();
			self.open();
		} else if (e.key === 'ArrowUp' && self.hasClass('-active')) {
			e.preventDefault();
			self.collapse();
		}
	});
	self.parent.children('svg').click(function(e) {
		var that = this;
		e.preventDefault();
		self.toggle();
		setTimeout(function() {
			$(that).closest('.scroll-container').getNiceScroll().resize();
		}, 400);
	}).keydown(function(e) {
		if (e.key === 'ArrowDown' && !self.hasClass('-active')) {
			e.preventDefault();
			self.open();
		} else if (e.key === 'ArrowUp' && self.hasClass('-active')) {
			e.preventDefault();
			self.collapse();
		}
	});

	self.toggle = function() {
		var self = this;
		if (!self.hasClass('-active')) {
			if (self.closest('.dropdown-group').find('.dropdown.-active').length) {
				self.closest('.dropdown-group').find('.dropdown.-active').each(function() {
					$(this).data('accordion').collapse();
				});
				clearTimeout(self.t2);
				clearTimeout(self.t4);
				clearTimeout(self.t5);
				self.t5 = setTimeout(function() {
					self.open();
				},400);
			} else {
				self.open();
			}
		} else {
			self.collapse();
		}
	};

	self.open = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.addClass('-active');
		self.parent.children('svg[role="button"]').attr('aria-label', 'Zwiń (strzałka w górę)');
		self.attr('aria-expanded', 'true').attr('aria-hidden', 'false').removeAttr('inert').focus();
		if (self.hasClass('-animating')) {
			self.css({height:outerHeight});
		} else {
			self.addClass('-active');
			outerHeight = self.outerHeight();
			self.css({height:0});
			self.t1 = setTimeout(function() {
				self.addClass('-animating');
				self.parent.addClass('-opening');
				self.css({height:outerHeight});
			},10);
		}
		self.find('.slickSlider').slick('setPosition');
		self.t2 = setTimeout(function() {
			clearTimeout(self.t2);
			self.attr('style','').removeClass('-animating');
			self.parent.attr('style','').removeClass('-opening');
		},500);
	};

	self.collapse = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.removeClass('-active');
		this.attr('aria-expanded', 'false').attr('aria-hidden', 'true').attr('inert', true);
		if (self.hasClass('-animating')) {
			self.css({height:0});
		} else {
			self.css({height:outerHeight});
			self.t3 = setTimeout(function() {
				self.addClass('-animating');
				self.css({height:0});
			},10);
		}
		self.t4 = setTimeout(function() {
			clearTimeout(self.t4);
			self.attr('style','').removeClass('-active').removeClass('-animating');
		},500);
	};
};